<template>
  <div id="fleets">
    <!-- the user has no cluster => display the warning page -->
    <!-- check true and false to not display anything while it's null -->
    <no-groups v-if="this.$store.getters.userHasFleets===false" groups="fleets" />

    <template v-else>
      <select-group group="fleet" />

      <div class="row">
        <div class="col-lg-5">
          <synthesis :update="updateChild" :total-count="gatewaysCount" :last-events-counters="lastEventsCounters" />
        </div>
        <div class="col-lg-7">
          <fleets-map />
        </div>
      </div>

      <overview :update="updateChild" :total-count="gatewaysCount" :last-events-counters="lastEventsCounters" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

import NoGroups from '@/components/page/errors/NoGroups'
import Synthesis from './Synthesis'
import FleetsMap from './Map'
import Overview from './Overview'

export default {
  titleKey: 'fleets',

  components: { NoGroups, Synthesis, FleetsMap, Overview },

  data () {
    return {
      // Update time, used to trigger and update from parent when all requests are done here
      updateChild: 0,
      gatewaysCount: 0,
      lastEventsCounters: {}
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['selectedFleet'])
  },

  watch: {
    // When selectedFleet change, get gateway count for this fleet
    selectedFleet: 'getFleetStats'
  },

  methods: {
    async getFleetStats () {
      let error, responses
      [error, responses] = await to(Promise.all([this.getFleetGatewaysCount(), this.getFleetGatewaysLastEventsCounters()]))
      if (error || !responses) return

      this.gatewaysCount = responses[0].data.totalCount
      this.lastEventsCounters = responses[1].data
      this.updateChild = Date.now()
    },

    getFleetGatewaysCount () {
      return this.$api.getGateways(this.selectedFleet, { page: 1, pageSize: 1 })
    },

    getFleetGatewaysLastEventsCounters () {
      return this.$api.getFleetLastEventsCounters(this.selectedFleet)
    }
  }
}
</script>
